import styles from "./CheckoutForm.module.css";

const METHODS = [
  { id: "ground",   label: "Ground (3–5 business days)", price: "Free over $250" },
  { id: "expedite", label: "Expedited (2 business days)", price: "+ $24.95" },
  { id: "overnight", label: "Overnight",                  price: "+ $59.00" },
];

export default function CheckoutShipping({ value, onChange, onNext }) {
  function field(k, v) { onChange({ ...value, [k]: v }); }
  function submit(e) {
    e.preventDefault();
    onNext?.();
  }

  return (
    <form onSubmit={submit} className={styles.form}>
      <h2 className={styles.section}>Ship To</h2>
      <div className={styles.grid2}>
        <Field label="Full name" required value={value.name} onChange={(v) => field("name", v)} />
        <Field label="Company" value={value.company} onChange={(v) => field("company", v)} />
        <Field label="Email" type="email" required value={value.email} onChange={(v) => field("email", v)} />
        <Field label="Phone" type="tel" value={value.phone} onChange={(v) => field("phone", v)} />
      </div>

      <Field label="Address line 1" required value={value.address1} onChange={(v) => field("address1", v)} />
      <Field label="Address line 2" value={value.address2} onChange={(v) => field("address2", v)} />

      <div className={styles.grid3}>
        <Field label="City" required value={value.city} onChange={(v) => field("city", v)} />
        <Field label="State" required value={value.state} onChange={(v) => field("state", v)} />
        <Field label="ZIP" required value={value.zip} onChange={(v) => field("zip", v)} />
      </div>

      <h2 className={styles.section} style={{ marginTop: 28 }}>Shipping Method</h2>
      <div className={styles.methods}>
        {METHODS.map((m) => (
          <label key={m.id} className={[styles.method, value.method === m.id ? styles.methodActive : ""].join(" ")}>
            <input
              type="radio"
              name="ship-method"
              value={m.id}
              checked={value.method === m.id}
              onChange={() => field("method", m.id)}
            />
            <span className={styles.methodLabel}>{m.label}</span>
            <span className={styles.methodPrice}>{m.price}</span>
          </label>
        ))}
      </div>

      <div className={styles.actions}>
        <button type="submit" className={styles.next}>Continue to Payment →</button>
      </div>
    </form>
  );
}

function Field({ label, value, onChange, type = "text", required = false }) {
  return (
    <label className={styles.field}>
      <span className={styles.fieldLabel}>{label}{required && <em>*</em>}</span>
      <input
        type={type}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        required={required}
        className={styles.input}
      />
    </label>
  );
}
